import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Importando o axios
import { ListAlt, Add, Download, ArrowForward, ArrowBack, DeleteOutline } from '@mui/icons-material'; // Ícones para os botões
import { jsPDF } from "jspdf";

// Definindo algumas categorias padrão
const categoriasPadrao = [
    { id: 1, nome: "Desp. Gerais" },
    { id: 2, nome: "Desp. Montagem/Instalação" },
    { id: 3, nome: "Desp. Alimentação" },
    { id: 4, nome: "Desp. Combustível" },
    { id: 5, nome: "Desp. Materiais" },
    { id: 6, nome: "Receita de venda" },
    { id: 7, nome: "Receita: Outros" },
];

const Lancamentos = ({ atualizarSaldo, fetchSaldo, fetchLucroBruto, fetchLucrosPrejuizosMensais, fetchGastos}) => {
    const [lancamentos, setLancamentos] = useState([]);
    const [openLançamentoModal, setOpenLançamentoModal] = useState(false);
    const [openExportModal, setOpenExportModal] = useState(false);
    const [lancamentoParaDeletar, setLancamentoParaDeletar] = useState(null); // Estado para o modal de deleção
    const [paginaAtual, setPaginaAtual] = useState(0);  // Índice da página atual (para navegação)
    const [ano, setAno] = useState(new Date().getFullYear());  // Ano atual

    const lancamentosPorPagina = 5;  // Quantidade de lançamentos a exibir por vez

    const fetchLancamentos = async (ano) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/releasesRoutes/lancamentos?ano=${ano}`);
            // Ordenando os lançamentos pela data (do mais recente para o mais antigo)
            const lancamentosOrdenados = response.data.sort((a, b) => {
                // Convertendo as datas em objetos Date
                const dataA = new Date(a.data);
                const dataB = new Date(b.data);

                // Comparando as datas (dataB - dataA para que as mais recentes apareçam primeiro)
                return dataB - dataA;
            });

            // Atualizando o estado com os lançamentos ordenados
            setLancamentos(lancamentosOrdenados);

        } catch (error) {
            console.error('Erro ao buscar lançamentos:', error);
        }
    };

    // Função para adicionar um novo lançamento
    const handleAdicionarLancamento = async (categoria, valor, isReceita, descricao) => {
        const tipo = isReceita ? 'receita' : 'despesa'; // Definindo o tipo com base na escolha

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/releasesRoutes/lancamentos`, {
                tipo,
                valor: isReceita ? valor : -valor,
                categoria,
                descricao, // Agora passando a descrição para o backend
                data: new Date().toISOString(),
            });
            fetchLancamentos(ano);  // Recarrega os lançamentos após adicionar

            // Atualiza o saldo após adicionar um lançamento
            atualizarSaldo(isReceita ? valor : -valor);

            // Recarrega o saldo de caixa
            await fetchSaldo();
            await fetchLucroBruto();
            await fetchLucrosPrejuizosMensais();
            await fetchGastos();

        } catch (error) {
            console.error('Erro ao adicionar lançamento:', error);
        }
    };

    const handleExportarLancamentos = (periodoSelecionado) => {
        const hoje = new Date();
        let dataInicio;

        switch (periodoSelecionado) {
            case 'mensal':
                dataInicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
                break;
            case 'trimestral':
                dataInicio = new Date(hoje.getFullYear(), hoje.getMonth() - 2, 1);
                break;
            case 'semestral':
                dataInicio = new Date(hoje.getFullYear(), hoje.getMonth() - 5, 1);
                break;
            case 'anual':
                dataInicio = new Date(hoje.getFullYear(), 0, 1);
                break;
            default:
                dataInicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
                break;
        }

        // Filtro dos lançamentos baseado no período
        const lancamentosFiltrados = lancamentos.filter(l => {
            const dataLancamento = new Date(l.data);
            return dataLancamento >= dataInicio && dataLancamento <= hoje;
        });

        const doc = new jsPDF();
        const titulo = `Relatório de Lançamentos (${periodoSelecionado})`;
        doc.setFontSize(18);
        doc.text(titulo, 14, 20);

        doc.setFontSize(12);
        const headers = [["Descrição", "Categoria", "Valor (R$)", "Data"]];

        const dadosParaPDF = lancamentosFiltrados.map(l => ([
            l.descricao || '',
            l.categoria || '',
            (parseFloat(l.valor)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            new Date(l.data).toLocaleDateString('pt-BR')
        ]));

        let contentY = 30;

        headers.concat(dadosParaPDF).forEach((row, rowIndex) => {
            let line = row.join(" | ");
            if (contentY > 270) {
                doc.addPage();
                contentY = 20;
            }
            if (rowIndex === 0) {
                doc.setFont(undefined, 'bold');
            } else {
                doc.setFont(undefined, 'normal');
            }
            doc.text(line, 14, contentY);
            contentY += 8;
        });

        doc.save(`lancamentos-${periodoSelecionado}.pdf`);
    };

    const confirmarDelecao = (id) => {
        setLancamentoParaDeletar(id);
    };

    const handleDeleteLancamento = async () => {
        if (!lancamentoParaDeletar) return;
        
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/releasesRoutes/lancamentos/${lancamentoParaDeletar}`);
            
            // Recarrega todos os dados afetados
            fetchLancamentos(ano);
            await fetchSaldo();
            await fetchLucroBruto();
            await fetchLucrosPrejuizosMensais();
            await fetchGastos();
            setLancamentoParaDeletar(null); // Fecha o modal após sucesso
        } catch (error) {
            console.error('Erro ao deletar lançamento:', error);
        }
    };

    const handleProximaPagina = () => {
        if ((paginaAtual + 1) * lancamentosPorPagina < lancamentos.length) {
            setPaginaAtual(paginaAtual + 1);
        }
    };

    // Função de navegação para a página anterior
    const handlePaginaAnterior = () => {
        if (paginaAtual > 0) {
            setPaginaAtual(paginaAtual - 1);
        }
    };

    // Filtra os lançamentos para a página atual
    const lancamentosVisiveis = lancamentos.slice(
        paginaAtual * lancamentosPorPagina,
        (paginaAtual + 1) * lancamentosPorPagina
    );

    useEffect(() => {
        fetchLancamentos(ano); // Carrega os lançamentos do ano atual quando o componente é montado
    }, [ano]);

    return (
        <div>
            <div className="flex justify-between items-center mb-4">
                <div className="flex items-center">
                    <ListAlt className="text-3xl text-gray-200 mr-4" />
                    <h2 className="text-2xl font-semibold text-gray-200">Lançamentos Mensais</h2>
                </div>
                <div className="flex space-x-4">
                    <button
                        onClick={() => setOpenLançamentoModal(true)}
                        className="bg-green-500 text-white p-2 rounded-full hover:bg-green-600 transition-colors"
                    >
                        <Add />
                    </button>
                    <button
                        onClick={() => setOpenExportModal(true)}
                        className="bg-blue-500 text-white p-2 rounded-full hover:bg-blue-600 transition-colors"
                    >
                        <Download />
                    </button>
                </div>
            </div>

            {/* Lista de Lançamentos com Navegação */}
            <ul className="space-y-4">
                {lancamentosVisiveis.map((lancamento) => (
                    <li key={lancamento.id} className="glass-panel p-3 flex justify-between items-center text-gray-200">
                        <span>{lancamento.descricao}</span>
                        <div className="flex items-center space-x-4">
                            <span className={lancamento.valor < 0 ? "text-red-500 font-bold" : "text-green-500 font-bold"}>
                                {lancamento.valor < 0 ? `- R$ ${Math.abs(lancamento.valor)}` : `+ R$ ${lancamento.valor}`}
                            </span>
                            <button 
                                onClick={() => confirmarDelecao(lancamento.id)}
                                className="text-red-400 hover:text-red-500 transition-colors p-1 rounded-full hover:bg-white/10"
                                title="Apagar lançamento e estornar valor"
                            >
                                <DeleteOutline />
                            </button>
                        </div>
                    </li>
                ))}
            </ul>

            {/* Controles de Navegação */}
            <div className="flex justify-center items-center mt-4">
                <button
                    onClick={handlePaginaAnterior}
                    className="p-2 bg-white/10 text-white rounded-full hover:bg-white/20 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                    disabled={paginaAtual === 0}
                >
                    <ArrowBack />
                </button>
                <button
                    onClick={handleProximaPagina}
                    className="p-2 ml-3 bg-white/10 text-white rounded-full hover:bg-white/20 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                    disabled={(paginaAtual + 1) * lancamentosPorPagina >= lancamentos.length}
                >
                    <ArrowForward />
                </button>
            </div>

            {/* Modal de Lançamento */}
            {openLançamentoModal && (
                <LançamentoModal
                    onClose={() => setOpenLançamentoModal(false)}
                    onSubmit={handleAdicionarLancamento}
                />
            )}

            {/* Modal de Exportação */}
            {openExportModal && (
                <ExportModal
                    onClose={() => setOpenExportModal(false)}
                    onSubmit={handleExportarLancamentos}
                />
            )}

            {/* Modal de Exclusão */}
            {lancamentoParaDeletar && (
                <DeleteConfirmModal
                    onClose={() => setLancamentoParaDeletar(null)}
                    onConfirm={handleDeleteLancamento}
                />
            )}
        </div>
    );
};

const LançamentoModal = ({ onClose, onSubmit }) => {
    const [categoria, setCategoria] = useState('');
    const [valor, setValor] = useState('');
    const [tipoLancamento, setTipoLancamento] = useState('receita');
    const [descricao, setDescricao] = useState(''); // Novo estado para a descrição
    const [erro, setErro] = useState('');

    const handleSubmit = () => {
        if (!categoria) {
            setErro('Por favor, selecione uma categoria.');
            return;
        }

        if (!valor || valor <= 0) {
            setErro('Por favor, insira um valor válido.');
            return;
        }

        if (!descricao) {
            setErro('Por favor, insira uma descrição.');
            return;
        }

        const isReceita = tipoLancamento === 'receita'; // Se for 'receita', valor é positivo
        
        if (isReceita && !categoria.toLowerCase().startsWith("receita")) {
            setErro("Para lançar uma receita você deve selecionar uma categoria de Receita.");
            return;
        }

        if (!isReceita && !categoria.toLowerCase().startsWith("desp")) {
            setErro("Para lançar uma despesa você deve selecionar uma categoria de Despesa.");
            return;
        }

        onSubmit(categoria, parseFloat(valor), isReceita, descricao); // Passando a descrição
        onClose();
    };

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black/70 backdrop-blur-md z-50">
            <div className="glass-panel p-6 w-full max-w-2xl text-white bg-slate-900/90 shadow-2xl border-white/10 relative">
                <h2 className="text-2xl font-semibold text-gray-200 mb-4">Novo Lançamento</h2>
                <select
                    value={categoria}
                    onChange={(e) => setCategoria(e.target.value)}
                    className="glass-select w-full mb-4"
                >
                    <option value="">Selecione a Categoria</option>
                    {categoriasPadrao.map((cat) => (
                        <option key={cat.id} value={cat.nome}>{cat.nome}</option>
                    ))}
                </select>

                <input
                    type="number"
                    value={valor}
                    onChange={(e) => setValor(e.target.value)}
                    placeholder="Valor"
                    className="glass-input w-full mb-4"
                />

                {/* Campo de descrição */}
                <textarea
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                    placeholder="Descrição do Lançamento"
                    className="glass-input w-full mb-6 resize-none"
                    rows="4"
                />

                {erro && <p className="text-red-500 text-sm mb-4">{erro}</p>}

                <div className="grid grid-cols-2 gap-4 mb-6">
                    <label className="relative flex items-center p-3 cursor-pointer group bg-white/5 rounded-xl hover:bg-white/10 transition-all border border-white/5 hover:border-white/20">
                        <input
                            type="radio"
                            name="tipoLancamento"
                            value="receita"
                            checked={tipoLancamento === 'receita'}
                            onChange={() => setTipoLancamento('receita')}
                            className="peer sr-only"
                        />
                        <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full border-2 border-gray-500 peer-checked:border-green-500 peer-checked:bg-green-500 transition-all shadow-none peer-checked:shadow-[0_0_10px_rgba(34,197,94,0.6)]">
                            <div className="w-2.5 h-2.5 bg-white rounded-full opacity-0 peer-checked:opacity-100 transition-opacity"></div>
                        </div>
                        <span className="ml-3 text-gray-300 font-medium group-hover:text-white peer-checked:text-white transition-colors">Receita</span>
                    </label>

                    <label className="relative flex items-center p-3 cursor-pointer group bg-white/5 rounded-xl hover:bg-white/10 transition-all border border-white/5 hover:border-white/20">
                        <input
                            type="radio"
                            name="tipoLancamento"
                            value="despesa"
                            checked={tipoLancamento === 'despesa'}
                            onChange={() => setTipoLancamento('despesa')}
                            className="peer sr-only"
                        />
                        <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full border-2 border-gray-500 peer-checked:border-red-500 peer-checked:bg-red-500 transition-all shadow-none peer-checked:shadow-[0_0_10px_rgba(239,68,68,0.6)]">
                            <div className="w-2.5 h-2.5 bg-white rounded-full opacity-0 peer-checked:opacity-100 transition-opacity"></div>
                        </div>
                        <span className="ml-3 text-gray-300 font-medium group-hover:text-white peer-checked:text-white transition-colors">Despesa</span>
                    </label>
                </div>

                <div className="flex space-x-4">
                    <button onClick={handleSubmit} className="glass-button w-full shadow-[0_0_15px_rgba(59,130,246,0.5)]">
                        Adicionar
                    </button>
                    <button onClick={onClose} className="glass-button-danger w-full">
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
};


const ExportModal = ({ onClose, onSubmit }) => {
    const [periodo, setPeriodo] = useState('');
    const [erro, setErro] = useState('');

    const handleExport = () => {
        if (!periodo) {
            setErro("Por favor, selecione um período.");
            return;
        }
        onSubmit(periodo);
        onClose();
    };

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black/70 backdrop-blur-md z-50">
            <div className="glass-panel p-6 w-full max-w-2xl text-white bg-slate-900/90 shadow-2xl border-white/10 relative">
                <h2 className="text-2xl font-semibold text-gray-200 mb-4">Exportar Lançamentos</h2>
                <select
                    value={periodo}
                    onChange={(e) => setPeriodo(e.target.value)}
                    className="glass-select mb-4 w-full"
                >
                    <option value="" disabled>Selecione um Período</option>
                    <option value="mensal">Mensal</option>
                    <option value="semestral">Semestral</option>
                    <option value="anual">Anual</option>
                </select>
                
                {erro && <p className="text-red-500 text-sm mb-4">{erro}</p>}

                <div className="flex justify-center space-x-1">
                    <button onClick={handleExport} className="bg-blue-500 text-white py-2 px-4 rounded-lg">
                        Exportar
                    </button>
                    <button onClick={onClose} className="bg-gray-500 text-white py-2 px-4 rounded-lg">
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
};

// Componente do Modal de Confirmação de Exclusão
const DeleteConfirmModal = ({ onClose, onConfirm }) => {
    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black/70 backdrop-blur-md z-50">
            <div className="glass-panel p-6 w-full max-w-md text-white bg-slate-900/90 shadow-2xl border-white/10 relative text-center">
                <h2 className="text-2xl font-semibold text-red-400 mb-4">Atenção!</h2>
                <p className="text-gray-300 mb-6">Tem certeza que deseja apagar este lançamento? O valor será <b className="text-red-400">estornado</b> do caixa automaticamente.</p>
                
                <div className="flex space-x-4">
                    <button onClick={onConfirm} className="glass-button-danger w-full shadow-[0_0_15px_rgba(239,68,68,0.5)]">
                        Sim, Apagar
                    </button>
                    <button onClick={onClose} className="glass-button w-full bg-gray-600 hover:bg-gray-700">
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Lancamentos;
